import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PageResult } from "src/app/domain/models/PageResult";
import { NewPort, Port } from "src/app/domain/models/Port";

@Injectable({providedIn: 'root'})
export abstract class PortGateway {
  abstract getAll(): Observable<Port[]>
  abstract getOriginPorts(): Observable<Port[]>
  abstract getDestinationPortsByCountry(countryId: number): Observable<Port[]>
  abstract create(port: NewPort): Observable<Port>
  abstract getAllPaged(pageNumber: number, pageSize: number): Observable<PageResult<Port>>
}
